const user = {
    id_already_in_use: 'این شناسه کاربری از قبل در حال استفاده است.',
    username_already_in_use: 'این نام کاربری از قبل در حال استفاده است.',
    username_starts_with_number: 'نام کاربری نمی‌تواند با عدد شروع شود.',
    username_invalid_charset_hard: 'نام کاربری فقط می‌تواند شامل حروف، اعداد و زیرخط باشد.',
    username_too_short: 'نام کاربری خیلی کوتاه است.',
    username_too_long: 'نام کاربری خیلی بلند است.',
    username_uppercase_not_allowed: 'نام کاربری نمی‌تواند شامل حروف بزرگ باشد.',
    username_lowercase_not_allowed: 'نام کاربری نمی‌تواند شامل حروف کوچک باشد.',
    username_numbers_not_allowed: 'نام کاربری نمی‌تواند شامل اعداد باشد.',
    username_underscore_not_allowed: 'نام کاربری نمی‌تواند شامل زیرخط باشد.',
    email_already_in_use: 'این ایمیل به حساب موجودی متصل است.',
    phone_already_in_use: 'این شماره تلفن به حساب موجودی متصل است.',
    invalid_email: 'آدرس ایمیل نامعتبر است.',
    invalid_phone: 'شماره تلفن نامعتبر است.',
    email_not_exist: 'آدرس ایمیل هنوز ثبت نشده است.',
    phone_not_exist: 'شماره تلفن هنوز ثبت نشده است.',
    identity_not_exist: 'حساب اجتماعی هنوز ثبت نشده است.',
    sso_identity_not_exist: 'حساب SSO سازمانی هنوز ثبت نشده است.',
    identity_already_in_use: 'حساب اجتماعی به حساب موجودی متصل شده است.',
    social_account_exists_in_profile: 'این حساب اجتماعی را از قبل متصل کرده‌اید.',
    cannot_delete_self: 'نمی‌توانید خودتان را حذف کنید.',
    sign_up_method_not_enabled: 'این روش ثبت‌نام فعال نیست.',
    sign_in_method_not_enabled: 'این روش ورود فعال نیست.',
    same_password: 'رمز عبور جدید نمی‌تواند با رمز عبور قبلی یکسان باشد.',
    password_required_in_profile: 'قبل از ورود باید رمز عبور تنظیم کنید.',
    new_password_required_in_profile: 'باید رمز عبور جدید تنظیم کنید.',
    password_exists_in_profile: 'رمز عبور از قبل در پروفایل شما وجود دارد.',
    username_required_in_profile: 'قبل از ورود باید نام کاربری تنظیم کنید.',
    username_exists_in_profile: 'نام کاربری از قبل در پروفایل شما وجود دارد.',
    email_required_in_profile: 'قبل از ورود باید آدرس ایمیل اضافه کنید.',
    email_exists_in_profile: 'پروفایل شما از قبل به آدرس ایمیلی متصل است.',
    phone_required_in_profile: 'قبل از ورود باید شماره تلفن اضافه کنید.',
    phone_exists_in_profile: 'پروفایل شما از قبل به شماره تلفنی متصل است.',
    email_or_phone_required_in_profile: 'قبل از ورود باید آدرس ایمیل یا شماره تلفن اضافه کنید.',
    suspended: 'این حساب معلق است.',
    user_not_exist: 'کاربر با {{ identifier }} وجود ندارد.',
    missing_profile: 'قبل از ورود باید اطلاعات اضافی ارائه دهید.',
    role_exists: 'شناسه نقش {{roleId}} از قبل به این کاربر اضافه شده است',
    invalid_role_type: 'نوع نقش نامعتبر است؛ نمی‌توان نقش ماشین به ماشین را به کاربر اختصاص داد.',
    suggest_mfa: 'برای امنیت بهتر حساب، اتصال MFA به حساب خود را پیشنهاد می‌کنیم.',
    missing_mfa: 'قبل از ورود باید MFA اضافی متصل کنید.',
    totp_already_in_use: 'TOTP از قبل در حال استفاده است.',
    backup_code_already_in_use: 'کد پشتیبان از قبل در حال استفاده است.',
    password_algorithm_required: 'الگوریتم رمز عبور الزامی است.',
    password_and_digest: 'نمی‌توانید همزمان رمز عبور متنی و digest رمز عبور تنظیم کنید.',
    personal_access_token_name_exists: 'نام توکن دسترسی شخصی از قبل وجود دارد.',
    personal_access_token_limit_exceeded: 'شما حداکثر می‌توانید {{limit}} توکن دسترسی شخصی فعال داشته باشید.',
    personal_access_token_invalid_expiration: 'زمان انقضا باید در آینده باشد و بیش از {{maxDays}} روز از اکنون نباشد.',
    totp_secret_invalid: 'secret TOTP ارائه‌شده نامعتبر است.',
    wrong_backup_code_format: 'قالب کد پشتیبان نامعتبر است.',
    username_required: 'نام کاربری شناسه الزامی است؛ نمی‌توانید آن را null تنظیم کنید.',
    email_or_phone_required: 'آدرس ایمیل یا شماره تلفن شناسه الزامی است؛ حداقل یکی لازم است.',
    last_sign_in_method_required: 'باید حداقل یک شناسه در حساب خود نگه دارید.',
    email_required: 'آدرس ایمیل شناسه الزامی است؛ نمی‌توانید آن را null تنظیم کنید.',
    phone_required: 'شماره تلفن شناسه الزامی است؛ نمی‌توانید آن را null تنظیم کنید.',
    enterprise_sso_identity_not_exists: 'کاربر هویت سازمانی متصل به شناسه اتصال‌دهنده SSO مشخص‌شده ندارد: {{ ssoConnectorId }}.',
    identity_not_exists_in_current_user: 'هویت مشخص‌شده در حساب کاربر فعلی وجود ندارد. لطفاً قبل از ادامه هویت را متصل کنید.',
    passkey_preferred: 'برای ساده‌تر کردن فرایند ورود، passkey ایجاد کنید.',
};
export default Object.freeze(user);
